export class LinkedListNode<T> {
  private value: T;
  private next: LinkedListNode<T> | null = null;

  constructor(value: T) {
    this.value = value;
  }

  public setValue(value: T): LinkedListNode<T> {
    this.value = value;
    return this;
  }

  public getValue(): T {
    return this.value;
  }

  public setNext(next: LinkedListNode<T>): LinkedListNode<T> {
    this.next = next;
    return this;
  }

  public getNext(): LinkedListNode<T> | null {
    return this.next;
  }

  public hasNext(): boolean {
    return this.next !== null;
  }

  public clone(): LinkedListNode<T> {
    const clonedNode = new LinkedListNode<T>(this.value);
    if (this.next) {
      clonedNode.setNext(this.next.clone());
    }
    return clonedNode;
  }
}
